import { pushFaroEvent } from '../faroSession';
import _ from 'lodash';

const calculateRMS = (arrayData: any) => {
    let squareValue = _.reduce(arrayData, (rmsValue: any, ele: any) => rmsValue + (ele * ele), 0.0);
    return Math.sqrt(squareValue / arrayData.length)

}


export const fetchMeanValue = async (audioBlob?: any) => {
    if (audioBlob) {
        const audioContext = new (window.AudioContext)();
        const arrayBuffer = await audioBlob.arrayBuffer();
        // Decode the audio data
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const samples = audioBuffer.getChannelData(0);
        let filteredVoiceData = _.filter(samples, (value: any) => value > 0);
        let meanValue = calculateRMS(filteredVoiceData);
        pushFaroEvent('threshold_level_calculated', { meanValue: String(meanValue) });
        return meanValue;

    } else {
        pushFaroEvent('threshold_calculation_skipped', { reason: 'no_audio_data' });
    }
}


export const isSilenceDetectedForGivenTime = (audioRecorder: any, time: any, silenceThreshold: any) => {
    if (audioRecorder?.mediaRecorder) {
        const audioContext = new AudioContext();
        const mediaStreamAudioSourceNode = audioContext.createMediaStreamSource(audioRecorder?.mediaRecorder?.stream);
        const analyserNode = audioContext.createAnalyser();
        mediaStreamAudioSourceNode.connect(analyserNode);
        const pcmData = new Float32Array(analyserNode.fftSize);
        let audioData: any = [];
        const onFrame = () => {
            analyserNode.getFloatTimeDomainData(pcmData);
            let resultValue = calculateRMS(pcmData)
            audioData.push(resultValue);
        }
        let intervalId = window.setInterval(() => {
            onFrame()
        }, 100);

        return new Promise((resolve) => {
            setTimeout(() => {
                // if( calculateRMSValue ) {
                //     resolve( returnRMSValue( audioData,  mediaStreamAudioSourceNode, analyserNode ))
                // } else {
                resolve(checkForSilence(audioData, silenceThreshold, mediaStreamAudioSourceNode, analyserNode, time));
                // }
                clearInterval(intervalId)
            }, time)
        })
    }
}

const checkForSilence = (audioData: any, silenceThreshold: any, mediaStreamAudioSourceNode: any, analyserNode: any, analyseTime: any) => {
    let isSilence = false;
    mediaStreamAudioSourceNode?.disconnect();
    analyserNode?.disconnect();
    let latestThreshold = silenceThreshold ;
    let analysePercentage  = .30;
    if( analyseTime <= 1000 ) {
        analysePercentage = .40;
    }
    let talkingData = _.filter(audioData, (ele: any) => ele > latestThreshold);
    if (talkingData.length > Math.floor(audioData.length * analysePercentage)) {
        return isSilence
    } else {
        isSilence = true;
        return isSilence;
    }

}

export const checkForHeadset = (micList: any) => {
    return micList.find((mic: any) => mic?.label?.includes('Headset'))
}

export function isHeadsetMicrophone(deviceLabel: any) {
    const headsetKeywords = [
        'epos'
    ];

    const lowerLabel = deviceLabel.toLowerCase();

    // Check for headset indicators
    if (headsetKeywords.some(keyword => lowerLabel.includes(keyword))) {
        return true;
    } else {
        return false;
    }

}

export const formatDuration = (ms: number, double: boolean = false) => {
    if (double) {
         const seconds = ms / 1000;
        return parseFloat(seconds.toFixed(2));
    }
 
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return minutes > 0
      ? `${minutes}min ${seconds}secs`
      : `${seconds}secs`;
  };